import { render } from "./ReportQuick.vue?vue&type=template&id=a496b104&scoped=true"
import script from "./ReportQuick.vue?vue&type=script&lang=js"
export * from "./ReportQuick.vue?vue&type=script&lang=js"

import "./ReportQuick.vue?vue&type=style&index=0&id=a496b104&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a496b104"]])

export default __exports__